import { memo } from 'react'
import { useDismissal } from '@features/engagement/dismissals'

const UnboundHelpButton = () => {
  const { reset } = useDismissal('unbound.onboarding')

  const onClick = () => {
    reset()
  }

  return (
    <button type="button" onClick={onClick} title="Help" className="help-button">
      <span>Help</span>
    </button>
  )
}

export default memo(UnboundHelpButton)
